import { Button, Card, Col, Layout, Modal, Row } from "antd";
import Typography from "antd/es/typography/Typography";
import { useEffect, useState } from "react";

const { Content } = Layout;

type Produto = {
    nome: string;
    descricao: string;
    imagem: string;
    lamina?: string; // A propriedade 'lamina' agora é opcional
};

const categorias = [
    {
        titulo: "Impermeabilizantes",
        produtos: [
            { nome: "Duraflex P.U. Premium", descricao: "Duraflex P.U. Premium", imagem: "/produtos/impermeabilizantes/imperm/DuraflexPUPremium.webp", lamina: '/produtos/impermeabilizantes/imperm/DuraflexPUPremium.webp' },
            { nome: "Duracit Tradicional", descricao: "Duracit Tradicional", imagem: "/produtos/impermeabilizantes/imperm/Duracit_Tradicional.webp", lamina: '/produtos/impermeabilizantes/imperm/Duracit_Tradicional.webp' },
            { nome: "Duralit", descricao: "Duralit", imagem: "/produtos/impermeabilizantes/imperm/Duralit.webp", lamina: '/produtos/impermeabilizantes/imperm/Duralit.webp' },
            { nome: "Duratherm", descricao: "Duratherm", imagem: "/produtos/impermeabilizantes/imperm/Duratherm.webp", lamina: '/laminas/impermeabilizantes/imperm/produtos/impermeabilizantes/imperm/Duratherm.webp' },
            { nome: "Selador Impermeabilizante", descricao: "Selador Impermeabilizante", imagem: "/produtos/impermeabilizantes/imperm/Selador_Impermeabilizante.webp", lamina: '/laminas/impermeabilizantes/imperm/produtos/impermeabilizantes/imperm/Selador_Impermeabilizante.webp' },
            { nome: "Durafix Tinta Asfáltica", descricao: "Durafix Tinta Asfáltica", imagem: "/produtos/impermeabilizantes/imperm/Durafix_Tinta_Asfaltica.webp", lamina: '/produtos/impermeabilizantes/imperm/Durafix_Tinta_Asfaltica.webp' },
            { nome: "Duratop Flex", descricao: "Duratop Flex", imagem: "/produtos/impermeabilizantes/imperm/Duratop_Flex.webp", lamina: '/produtos/impermeabilizantes/imperm/Duratop_Flex.webp' },
            { nome: "Desmoldante", descricao: "Desmoldante", imagem: "/produtos/impermeabilizantes/imperm/Desmoldante.webp", lamina: '/produtos/impermeabilizantes/imperm/Desmoldante.webp' },
            { nome: "Massa Asfaltica", descricao: "Massa Asfaltica", imagem: "/produtos/impermeabilizantes/imperm/Massa_Asfaltica.webp", lamina: '/produtos/impermeabilizantes/imperm/Massa_Asfaltica.webp' },
            { nome: "Duratop Flex Rodapé", descricao: "Duratop Flex Rodapé", imagem: "/produtos/impermeabilizantes/imperm/DuratopFlexRodape.webp", lamina: '/produtos/impermeabilizantes/imperm/DuratopFlexRodape.webp' },
            { nome: "Durafixador", descricao: "Durafixador", imagem: "/produtos/impermeabilizantes/imperm/Durafixador.webp", lamina: '/produtos/impermeabilizantes/imperm/Durafixador.webp' },
            { nome: "Super Manta Líquida", descricao: "Super Manta Liquida", imagem: "/produtos/impermeabilizantes/imperm/Super_Manta_Liquida.webp", lamina: '/produtos/impermeabilizantes/imperm/Super_Manta_Liquida.webp' },
            { nome: "Parede flex", descricao: "Parede flex", imagem: "/produtos/impermeabilizantes/imperm/Parede_flex.webp", lamina: '/produtos/impermeabilizantes/imperm/Parede_flex.webp' },
            { nome: "Duratop Semi-Flexível", descricao: "Duratop Semi-Flexível", imagem: "/produtos/impermeabilizantes/imperm/DuratopSemiFlexivel.webp", lamina: '/produtos/impermeabilizantes/imperm/DuratopSemiFlexivel.webp' },
        ],
    },
    {
        titulo: "Mantas Asfálticas",
        produtos: [
            { nome: "Manta Asfáltica Aluminizada", descricao: "Manta Asfáltica Aluminizada", imagem: "/produtos/impermeabilizantes/mantas_alfalticas/MANTA_ASFALTICA_ALUMINIZADA.webp", lamina: '/produtos/impermeabilizantes/mantas_alfalticas/MANTA_ASFALTICA_ALUMINIZADA.webp' },
            { nome: "Manta Asfáltica Alta Resistência", descricao: "Manta Asfáltica Alta Resistência", imagem: "/produtos/impermeabilizantes/mantas_alfalticas/MANTA_ASFALTICA_ALTA_RESISTENCIA.webp", lamina: '/produtos/impermeabilizantes/mantas_alfalticas/MANTA_ASFALTICA_ALTA_RESISTENCIA.webp' },
            { nome: "Primer Asfáltico", descricao: "Primer Asfáltico", imagem: "/produtos/impermeabilizantes/mantas_alfalticas/PRIMER_ASFALTICO.webp", lamina: '/produtos/impermeabilizantes/mantas_alfalticas/PRIMER_ASFALTICO.webp' },
        ],
    },
    {
        titulo: "Outros",
        produtos: [
            { nome: "Epoxi Estrutural", descricao: "Epoxi Estrutural", imagem: "/produtos/impermeabilizantes/outros/EPOXI_ESTRUTURAL.webp", lamina: '/produtos/impermeabilizantes/outros/EPOXI_ESTRUTURAL.webp' },
            { nome: "Vedatudo", descricao: "Epoxi Estrutural", imagem: "/produtos/impermeabilizantes/outros/VEDATUDO.webp", lamina: '/produtos/impermeabilizantes/outros/VEDATUDO.webp' },
        ],
    },
]; 

export default function ImpermeabilizantesPage() {
    const [modalVisible, setModalVisible] = useState(false);
    const [imagemModal, setImagemModal] = useState("");
    const [nomeProduto, setProdutoNome] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const [modalWidth, setModalWidth] = useState("50%");

    // Função para abrir o modal com a imagem
    const handleOpenModal = (imagem: string | undefined, nome: string) => {
        setImagemModal(""); // Limpa a imagem anterior
        setTimeout(() => {
            if (imagem) setImagemModal(imagem);
            setProdutoNome(nome);
            setModalVisible(true);
        }, 100); 
    };

    const handleCloseModal = () => {
        setModalVisible(false);
    };

    const handleDownload = () => {
        if (!imagemModal) return; // Evita erro caso não tenha imagem carregada
        const link = document.createElement("a");
        link.href = imagemModal;
        link.download = imagemModal.split("/").pop() || "imagem.png"; // Nome do arquivo é o nome da imagem
        link.click();
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setModalWidth("99%"); // Mobile
            } else {
                setModalWidth("50%"); // Desktop
            }
        };

        window.addEventListener("resize", handleResize);
        handleResize(); // Call once to set initial width

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <Layout>
            <Content className="content">
                <div className="container">
                    {categorias.map((categoria, index) => (
                        <div key={index} className="categoria">
                            <h2
                                className="categoria-titulo"
                                style={{
                                    backgroundColor: "#0647bd",
                                    color: "#fff",
                                    height: "50px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "left",
                                    margin: 0,
                                    paddingLeft: '20px'
                                }}
                            >
                                {categoria.titulo}
                            </h2>
                            <Row gutter={[16, 16]}>
                                {categoria.produtos.map((produto: Produto, i) => (
                                    <Col key={i} xs={24} sm={12} md={6} lg={6}>
                                        <Card style={{ textAlign: "center", padding: "15px" }}>
                                            <img
                                                alt={produto.nome}
                                                src={produto.imagem}
                                                style={{
                                                    width: "120px",
                                                    height: "160px",
                                                    objectFit: "contain",
                                                    display: "block",
                                                    margin: "0 auto",
                                                }}
                                                className="produto-imagem"
                                            />
                                            <h3 style={{ fontSize: "14px", marginTop: "10px", minHeight: "40px" }}>
                                                {produto.nome}
                                            </h3>
                                            <Button
                                                type="primary"
                                                style={{
                                                    backgroundColor: "#0647bd",
                                                    borderColor: "#0647bd",
                                                    color: "#fff",
                                                    width: "100%",
                                                    marginTop: "10px",
                                                }}
                                                onClick={() => handleOpenModal(produto.lamina, produto.nome)}
                                            >
                                                SAIBA MAIS
                                            </Button>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    ))}
                </div>
            </Content>

            <Modal
                visible={modalVisible}
                footer={null} // Remover footer para não sobrepor o botão
                onCancel={handleCloseModal}
                width="90%"
                style={{ maxWidth: modalWidth }} // Usando o valor de modalWidth
                title={
                    <Row style={{ alignItems: 'center', display: 'flex' }}>
                        <Button
                            key="download"
                            onClick={handleDownload}
                            style={{ width: '150px', marginBottom: '10px' }} // Tamanho fixo de 150px
                        >
                            Baixar Imagem
                        </Button>
                        <Typography style={{ marginLeft: '20px', marginBottom: '10px', fontSize: '20px' }}>
                            {nomeProduto}
                        </Typography>
                    </Row>
                }
            >
                <img src={imagemModal} alt="Lâmina" style={{ width: '100%', height: 'auto' }} />
            </Modal>
        </Layout>
    );
};
